<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->

<div class="search-n-download">
  <div class="lf-search-container">
    <span class="far fa-search cursor-pointer"></span>
    <img
      src="assets/img/svgs/normal_clear_u481.svg"
      class="clear-img"
      (click)="clearSearch()"
      *ngIf="employeeSearch.value !== ''"
    />
    <input
      #employeeSearch
      type="text"
      class="form-control"
      placeholder="Search"
      [(ngModel)]="searchValue"
      (ngModelChange)="searchInputChange($event)"
    />
  </div>
  <div class="lf-btn-download-container">
    <i
      class="fal fa-arrow-to-bottom"
      [placement]="'bottom'"
      tooltipClass="lf-box-tooltip"
      ngbTooltip="Download CSV"
      (click)="
        activeTab === 'Courses' ? exportCoursesData() : exportCertificatesData()
      "
    ></i>
  </div>
</div>
<div
  class="lf-nav-tabs"
  *ngIf="{
    courses: coursesPageData$ | async,
    certificates: certificatesPageData$ | async
  } as pageData"
>
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs"
    [activeId]="activeTab"
    (navChange)="activeTab = $event.nextId"
  >
    <ng-container [ngbNavItem]="'Courses'">
      <a ngbNavLink class="tab-name"
        >Courses Enrolled ({{ coursesCollectionSize }})</a
      >
      <ng-template ngbNavContent>
        <lfx-new-table
          [columns]="coursesColumns"
          [data]="pageData.courses || []"
          [version]="2"
          class="mb-4"
          [selectable]="false"
          [emptyDataMessage]="
            isCoursesLoading ? '' : 'No Activites found in this period.'
          "
        ></lfx-new-table>
        <lfx-ngb-pagination-wrapper
          *ngIf="coursesCollectionSize > 0"
          [collectionSize]="coursesCollectionSize"
          [page]="coursesPage$ | async"
          (pageChange)="onCoursesPageChange($event)"
          [pageSize]="coursesPageSize"
        ></lfx-ngb-pagination-wrapper>
      </ng-template>
    </ng-container>
    <ng-container [ngbNavItem]="'Certifications'">
      <a ngbNavLink class="tab-name"
        >Certifications Received ({{ certificatesCollectionSize }})</a
      >
      <ng-template ngbNavContent>
        <lfx-new-table
          [columns]="certificatesColumns"
          [data]="pageData.certificates || []"
          [version]="2"
          class="mb-4"
          [selectable]="false"
          [emptyDataMessage]="
            isCertificatesLoading ? '' : 'No Activites found in this period.'
          "
        ></lfx-new-table>
        <lfx-ngb-pagination-wrapper
          *ngIf="certificatesCollectionSize > 0"
          [collectionSize]="certificatesCollectionSize"
          [page]="certificatesPage$ | async"
          (pageChange)="onCertificatesPageChange($event)"
          [pageSize]="certificatesPageSize"
        ></lfx-ngb-pagination-wrapper>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class=""></div>
</div>
